<h2 mat-dialog-title>
  Informations de connexion
</h2>

<mat-dialog-content>

  <div class="identifier">
    {{ data.identifier }}
  </div>

  <div
    class="status ok"
    *ngIf="!data.locked">

    Compte actif

  </div>

  <div
    class="status ko"
    *ngIf="data.locked">

    Compte verrouillé

  </div>

  <div class="info-line">
    <span>Tentatives échouées</span>
    <strong>{{ data.failedAttempts }}</strong>
  </div>

  <div class="info-line">
    <span>Déverrouillage automatique</span>
    <strong>{{ data.minutesUntilUnlock }} min</strong>
  </div>

  <div
    class="info-line"
    *ngIf="data.lastSuccessAttempt">

    <span>Dernière connexion réussie</span>

    <strong>
      {{ data.lastSuccessAttempt | date:'dd/MM/yyyy HH:mm' }}
    </strong>

  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">

  <button
    mat-flat-button
    color="primary"
    (click)="close()">

    Fermer

  </button>

</mat-dialog-actions>